import React, { useState, useEffect } from 'react';

export const PAGE_SIZE_OPTIONS = [10, 20, 50, 100];
const DEFAULT_PAGE_SIZE = 10;

// Rows-per-page choice, remembered per table in localStorage.
export function usePageSize(key) {
  const storageKey = `pageSize:${key}`;
  const [pageSize, setPageSize] = useState(() => {
    try {
      const saved = Number(localStorage.getItem(storageKey));
      return PAGE_SIZE_OPTIONS.includes(saved) ? saved : DEFAULT_PAGE_SIZE;
    } catch { return DEFAULT_PAGE_SIZE; }
  });
  useEffect(() => {
    try { localStorage.setItem(storageKey, String(pageSize)); } catch { /* storage unavailable */ }
  }, [storageKey, pageSize]);
  return [pageSize, setPageSize];
}

export default function Pagination({ page, pageSize, total, label = '', onPageChange, onPageSizeChange }) {
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  return (
    <div className="pagination-bar">
      <label className="pagination-size">
        <span>Lignes</span>
        <select
          className="form-select"
          value={pageSize}
          onChange={e => onPageSizeChange(Number(e.target.value))}
        >
          {PAGE_SIZE_OPTIONS.map(n => <option key={n} value={n}>{n}</option>)}
        </select>
      </label>
      <div className="pagination-nav">
        <button className="btn btn-outline btn-sm" disabled={page <= 1} onClick={() => onPageChange(page - 1)}>← Préc.</button>
        <span className="pagination-info">Page {page} / {totalPages} ({total} {label})</span>
        <button className="btn btn-outline btn-sm" disabled={page >= totalPages} onClick={() => onPageChange(page + 1)}>Suiv. →</button>
      </div>
    </div>
  );
}
